var render = function render(){var _vm=this,_c=_vm._self._c;return _c('request-form',{attrs:{"vacancy-request-schema":_vm.vacancyRequestSchema,"vacancy-request":_vm.vacancyRequest,"data-qa":"vacancy_request_creation_form"},on:{"updated":_vm.handleUpdated},model:{value:(_vm.showCreateModal),callback:function ($$v) {_vm.showCreateModal=$$v},expression:"showCreateModal"}})
}
var staticRenderFns = []

export { render, staticRenderFns }